module.exports = __webpack_public_path__ + "assets/img/The Star Vista.be6d94ed.jpg";